import { useRef, useState } from "react";
import { LuFlame } from "react-icons/lu";
import AnchoredPanel from "../../shared/AnchoredPanel";
import MemoryPanel from "../MemoryPanel/MemoryPanel";
import { useGetPersistentMemory } from "../../../api/queryHooks";
import UserAuthStore from "../../../store/userStore";
import { useSparkContext } from "../../../context/SparkContext";
import CustomTooltip from "../../Tooltip/CustomTooltip";

const MemoryChip = () => {
  const { chat_id, isPersisted } = useSparkContext();
  const { orgId, user } = UserAuthStore.getState();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const isPersistedSpark = Boolean(chat_id && isPersisted);

  const { data } = useGetPersistentMemory(orgId, user?.uid, chat_id, {
    enabled: isPersistedSpark,
  });
  const entries = data?.entries ?? [];
  const activeCount = entries.filter((e) => !e.superseded).length;

  if (!isPersistedSpark) return null;

  return (
    <>
      <CustomTooltip
        content={
          activeCount > 0
            ? `Spark memory (${activeCount} active)`
            : "Spark memory (empty)"
        }
        side="top"
        align="center"
      >
        <button
          ref={anchorRef}
          onClick={() => setOpen((o) => !o)}
          className={`group w-[36px] h-[36px] flex items-center justify-center rounded-full hover:shadow-[0_0_0_0.5px_#6D808D4D] hover:bg-fill-navigation-hover hover:dark:bg-fill-navigation-hover-dark transition-colors relative ${
            open ? "bg-fill-navigation-hover dark:bg-fill-navigation-hover-dark" : ""
          }`}
          aria-label="View spark memory"
        >
          <LuFlame
            size={18}
            className={`${
              activeCount > 0
                ? "text-ink-primary dark:text-ink-accent"
                : "text-ink-control-border dark:text-ink-gray-400"
            }`}
          />
          {activeCount > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full bg-fill-primary text-ink-on-primary text-[9px] font-semibold flex items-center justify-center leading-none">
              {activeCount}
            </span>
          )}
        </button>
      </CustomTooltip>

      <AnchoredPanel
        anchorRef={anchorRef}
        isOpen={open}
        onClose={() => setOpen(false)}
        width={300}
      >
        <MemoryPanel />
      </AnchoredPanel>
    </>
  );
};

export default MemoryChip;
